module.exports = __webpack_public_path__ + "static/media/年度应收金额约定.1d8b6cb2.docx";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xieyi/年度应收金额约定.docx
// module id = 551
// module chunks = 0